import { content, imageUrl } from '../content';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import RoomsSection from '../components/RoomsSection';
import OutdoorSection from '../components/OutdoorSection';
import IndoorSection from '../components/IndoorSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar siteName={content.siteName} sections={content.sections} />
      <Hero content={content.hero} getImageUrl={imageUrl} />
      {content.sections.rooms.visible && (
        <RoomsSection content={content.rooms} getImageUrl={imageUrl} />
      )}
      {content.sections.outdoor.visible && (
        <OutdoorSection content={content.outdoor} getImageUrl={imageUrl} />
      )}
      {content.sections.indoor.visible && (
        <IndoorSection content={content.indoor} getImageUrl={imageUrl} />
      )}
      {content.sections.contact.visible && (
        <ContactSection content={content.contact} />
      )}
      <Footer />
    </div>
  );
}
